import Vue from 'vue';
import App from './app.vue';
// import BaiduMap from 'vue-baidu-map';
import {router} from './plugins/router/index';
import store from './plugins/store/index';
import i18n from './plugins/language/index';
import echarts from 'echarts'
// import './plugins/iview.js'
import 'iview/dist/styles/iview.css';
require('./styles/iview-base.less');
import VueClipboard from 'vue-clipboard2';
import GlobalPlugin from './plugins/my-plugins/vue-global';
import JsonExcel from 'vue-json-excel'


import puzzleVerification from 'vue-puzzle-verification'
Vue.use(puzzleVerification)
Vue.component('downloadExcel', JsonExcel);
Vue.use(VueClipboard)
Vue.use(GlobalPlugin)

// Vue.use(BaiduMap,{
//     // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
//     ak: '2XyOQN7chgjCGwqh753BgYZMRfkGupF9'
// })

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')

